function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
import React from "react";
export var IconEditUser = function IconEditUser(props) {
  return /*#__PURE__*/React.createElement("svg", _object_spread({
    width: "100",
    height: "100",
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4716_15607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.5709 31.783V86.6631C80.5709 92.9385 75.4746 98.0348 69.1992 98.0348H13.3365C7.06114 98.0348 1.96484 92.9385 1.96484 86.6631V30.8004C1.96484 24.525 7.06114 19.4287 13.3365 19.4287H68.2166L27.5511 60.1073L21.3674 78.6322L39.8923 72.4485L80.5709 31.783Z",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0343 10.6901C98.0343 12.9304 97.1827 15.1576 95.4796 16.8738L80.5706 31.7827L39.892 72.4483L21.3672 78.6319L27.5509 60.1071L68.2164 19.4285L83.1253 4.51954C86.5447 1.11328 92.0733 1.11328 95.4796 4.51954C97.1827 6.22267 98.0343 8.44984 98.0343 10.6901Z",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4746 9.02637L90.8289 21.3806",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.582 57.9199L41.9363 70.2742",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeMiterlimit: "10"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4716_15607"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100",
    height: "100",
    fill: "white"
  }))));
};